import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import M from "materialize-css/dist/js/materialize.min.js";
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CircularProgress from "@mui/material/CircularProgress";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { setAlert } from "../../../action/alert";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CloudDownload from '@mui/icons-material/CloudDownload';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { uploadIDUConfig, updateIDUConfigByModelId, updateIDUConfigByConfigId, getIDUConfigData, downloadIDUConfigFile, getDeviceModelNumbersList, sendIDUConfigMQTTTrigger, getDeviceModelIdsUsingConfigId } from './../../../action/iduConfig'
import Alert from "../../layout/Alert";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";
import { Box, useTheme } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { selectMenuProps } from '../../../utils/selectMenuProps';
import './IDUConfig.css';

const selectInputSx = { height: "3rem", width: "100%" };
const selectValuesSx = { width: "100%" };
const activeTabSx = { border: '1px solid #bdbdbd', backgroundColor: '#e0e0e0', color: '#333333', textTransform: 'capitalize' };
const nonActiveTabSx = { border: 'none', backgroundColor: 'none', color: '#333333', textTransform: 'capitalize' };
const formControlSx = (theme) => ({ width: "100%", maxWidth: "100%", [theme.breakpoints.up("md")]: { maxWidth: 280 } });

const headers = {
    modelId: "Model ID",
    configId: "Config ID",
    iduConfigVersion: "Config Version",
    iduConfigFileObjectBin: "Config File",
    editIDUConfig: "Edit"
};

const IDUEEPROMConfig = ({
    wrapperClass,
    allowedDeviceCategories,
    allowedCompanyBrand,
    iduConfigStore,
    uploadIDUConfig,
    downloadIDUConfigFile,
    sendIDUConfigMQTTTrigger,
    updateIDUConfigByModelId,
    updateIDUConfigByConfigId,
    setAlert
}) => {

    const theme = useTheme();
    const [activeTab, setActiveTab] = React.useState(0)
    const [uploadedIDUConfigData, setUploadedIDUConfigData] = useState({})
    const [editIduConfig, setEditIDUConfig] = useState(false)

    useEffect(() => {
        if (activeTab !== 1) {
            // active tab 1 is the upload/edit idu config tab
            // whenever the tab is changed/switched then reset the tab configs

            setEditIDUConfig(false)
            setUploadedIDUConfigData({})
        }
    }, [activeTab])

    function setIDUConfigDataForEdit(iduConfig) {
        // whenever the idu edit config icon is pressed, redirect the user
        // to upload/edit config tab
        // on edit, set the required idu configurations.

        setUploadedIDUConfigData(iduConfig)
        setEditIDUConfig(true)
        setActiveTab(1)
    }

    function handleCancelEditIduConfig() {
        // on editing the config, cancel button is shown. 
        // when user cancel the config edit, redirect user again to 
        // view page. But reset the upload/edit config page field values

        setActiveTab(0)
        setEditIDUConfig(false)
        setUploadedIDUConfigData({})
    }

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            <Alert />
            <Box className="row idu-eeprom-config" sx={{ width: "100%", minWidth: 0 }}>
                <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => {
                        setActiveTab(newValue)
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#bdbdbd"
                        }
                    }}
                    style={{ marginTop: 0 }}
                >
                    <Tab label="View IDU EEFROM Config" sx={activeTab == 0 ? activeTabSx : nonActiveTabSx} />
                    <Tab label="Upload IDU EEPROM Config" sx={activeTab == 1 ? activeTabSx : nonActiveTabSx} />
                    <Tab label="Push Device IDU Config" sx={activeTab == 2 ? activeTabSx : nonActiveTabSx} />
                </Tabs>
                <div hidden={activeTab !== 0}>
                    <ViewIDUEEPROMConfig
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        downloadIDUConfigFile={downloadIDUConfigFile}
                        setAlert={setAlert}
                        setIDUConfigDataForEdit={setIDUConfigDataForEdit}
                        iduConfigStore={iduConfigStore}
                    ></ViewIDUEEPROMConfig>
                </div>
                <div hidden={activeTab !== 1}>
                    <UploadIDUEEPROMConfig
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        iduConfigStore={iduConfigStore}
                        uploadedIDUConfigData={uploadedIDUConfigData}
                        editIDUConfig={editIduConfig}
                        uploadIDUConfig={uploadIDUConfig}
                        updateIDUConfigByModelId={updateIDUConfigByModelId}
                        updateIDUConfigByConfigId={updateIDUConfigByConfigId}
                        cancelEditIDUConfig={handleCancelEditIduConfig}
                        setAlert={setAlert}
                    ></UploadIDUEEPROMConfig>
                </div>
                <div hidden={activeTab !== 2}>
                    <MQTTTriggerIDUEEPROMConfig
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        iduConfigStore={iduConfigStore}
                        sendIDUConfigMQTTTrigger={sendIDUConfigMQTTTrigger}
                        setAlert={setAlert}
                    ></MQTTTriggerIDUEEPROMConfig>
                </div>
            </Box>
        </ResponsiveContentWrapper>
    );
}

const ViewIDUEEPROMConfig = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    downloadIDUConfigFile,
    setAlert,
    setIDUConfigDataForEdit,
    iduConfigStore: { uploadIDUConfigInProgress, uploadIDUConfigSuccess }
}) => {

    const [categoryFilter, setCategoryFilter] = useState("Select Category")
    const [brandFilter, setBrandFilter] = useState("Select Brand")
    const [modelNumberFilterList, setModelNumberFilterList] = useState([])
    const [modelNumberFilter, setModelNumberFilter] = useState("Select Model ID")
    const [configIdFilter, setConfigIdFilter] = useState("")
    const [iduConfigData, setIDUConfigData] = useState([])
    const [showIDUConfigDataList, setShowIDUConfigDataList] = useState(false)
    const [isIDUConfigDataLoading, setIsIDUConfigDataLoading] = useState(false)
    const [updateFlag, setUpdateFlag] = useState(undefined);
    const [searchBy, setSearchBy] = useState("searchByModelId")

    useEffect(() => {
        M.AutoInit();
    }, [])

    useEffect(()=>{
        if(!uploadIDUConfigInProgress && uploadIDUConfigSuccess) {
            setShowIDUConfigDataList(false)
        }

    }, [uploadIDUConfigInProgress, uploadIDUConfigSuccess])

    useEffect(() => {
        if (!categoryFilter || categoryFilter.length===0 || categoryFilter==="Select Category") {
            return
        }
        if (!brandFilter || brandFilter.length===0 || brandFilter==="Select Brand") {
            return
        }
        if (categoryFilter && categoryFilter.length!==0 && brandFilter && brandFilter.length!==0) {
            getDeviceModelNumbersList(brandFilter, categoryFilter)
                .then((data) => {
                    setModelNumberFilterList(data)
                    setShowIDUConfigDataList(false)
                    setModelNumberFilter("Select Model ID")
                })
                .catch((err) => {
                    setModelNumberFilterList([])
                    setShowIDUConfigDataList(false)
                    setModelNumberFilter("Select Model ID")
                })
        }
    }, [categoryFilter, brandFilter])

    useEffect(() => {
        if (searchBy==="searchByModelId") {
            if (categoryFilter==="Select Category" || categoryFilter.length===0 ||
                brandFilter==="Select Brand" || brandFilter.length===0 ||
                modelNumberFilter==="Select Model ID" || modelNumberFilter.length===0) {

                setShowIDUConfigDataList(false)
                setModelNumberFilterList([])
                setModelNumberFilter("Select Model ID")
            }
        }
        else if (searchBy==="searchByConfigId") {
            if (!configIdFilter || configIdFilter.length===0) {

                setShowIDUConfigDataList(false)
            }
        }
        else {
            // invalid selection filter
            setShowIDUConfigDataList(false)
        }
    }, [categoryFilter, brandFilter, modelNumberFilter, configIdFilter])

    useEffect(() => {
        if (searchBy==="searchByModelId") {
            if (!categoryFilter || categoryFilter.length===0 || categoryFilter==="Select Category") {
                return
            }
            if (!brandFilter || brandFilter.length===0 || brandFilter==="Select Brand") {
                return
            }
            if (!modelNumberFilter || modelNumberFilter.length===0 || modelNumberFilter==="Select Model ID") {
                return
            }
        }
        else if (searchBy==="searchByConfigId") {
            if (!configIdFilter || configIdFilter.length===0) {
                return
            }
        }
        else {
            return; //invalid filter selection
        }

        getIDUConfigFilterData();
    }, [updateFlag]);

    useEffect(() => {
        if (searchBy && searchBy.length!==0) {
            setShowIDUConfigDataList(false)
        }
    }, [searchBy])

    function filterIDUConfigData() {
        if (searchBy==="searchByModelId") {
            if (categoryFilter.length===0 || categoryFilter==="Select Category") {
                setAlert("Category Cannot be Empty", 'danger')
                return
            }

            if (brandFilter.length===0 || brandFilter==="Select Brand") {
                setAlert("Brand Cannot be Empty", 'danger')
                return
            }

            if (modelNumberFilter.length===0 || modelNumberFilter==="Select Model ID") {
                setAlert("Model ID Cannot be Empty", 'danger')
                return
            }
        }
        else if (searchBy==="searchByConfigId") {
            if (configIdFilter.length===0 || !configIdFilter) {
                setAlert("Config ID Cannot be Empty", 'danger')
                return
            }
        }
        else {
            setAlert("Invalid Filter", 'danger')
            return;
        }

        setUpdateFlag(Math.random());
    };

    function resetFilters() {
        setCategoryFilter("Select Category")
        setBrandFilter("Select Brand")
        setModelNumberFilter("Select Model ID")
        setConfigIdFilter("")
        setUpdateFlag(Math.random())
    };

    function downloadFile(fileData) {
        let params = {
            'fileData': fileData,
            'fileName': 'config.bin'
        }

        downloadIDUConfigFile(params)
    };

    function editIDUConfig(iduConfigVersion, iduConfigId, modelId) {
        if (searchBy==="searchByConfigId") {
            setIDUConfigDataForEdit({
                iduConfigVersion: iduConfigVersion,
                configId: iduConfigId,
                updateIDUConfigBy: "updateConfigByConfigId"
            })
        }
        else if (searchBy==="searchByModelId") {
            setIDUConfigDataForEdit({
                categoryName: categoryFilter,
                brandName: brandFilter,
                model: [{ "modelId": modelId, "modelNumber": JSON.parse(modelNumberFilter)["modelNumber"] }],
                iduConfigVersion: iduConfigVersion,
                configId: iduConfigId,
                updateIDUConfigBy: "updateConfigByModelId"
            })
        }
        else {
            //invalid selection of filters
        }
    }

    const getIDUConfigFilterData = () => {
        setIsIDUConfigDataLoading(true);

        let filteredParams = {}

        if (searchBy==="searchByConfigId") {
            // search on the basis of config id
            if (configIdFilter && configIdFilter.length!==0) {
                filteredParams['configId'] = configIdFilter
            }
        }
        else {
            // search on the bais of model id
            if (modelNumberFilter && modelNumberFilter.length!==0) {
                // get the model id only. We will show model number to users
                // but in background model id we are suing

                filteredParams['modelId'] = JSON.parse(modelNumberFilter)['modelId']
            }
        }

        getIDUConfigData(filteredParams)
            .then((res) => {
                setIsIDUConfigDataLoading(false);
                setShowIDUConfigDataList(true);
                setIDUConfigData(res);
            })
            .catch((err) => {
                setIsIDUConfigDataLoading(false);
                setShowIDUConfigDataList(false);
                setAlert("Failed to Get IDU EEPROM Config", "danger")
            });
    };

    function handleSearchByChange(event) {
        setSearchBy(event.target.value)
    }

    function handleEditByConfigId() {
        //here a single config id has the same config version

        setIDUConfigDataForEdit({
            iduConfigVersion: (iduConfigData && iduConfigData.length > 0) ? iduConfigData[0]["iduConfigVersion"] : "",
            configId: configIdFilter,
            updateIDUConfigBy: "updateConfigByConfigId"
        })
    }

    if (isIDUConfigDataLoading) {
        return <div style={{ display: "grid", placeItems: "center", height: "20vh" }}>
            <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
        </div>
    }

    return (
        <Fragment>
            <div className="content-block bottom-shadow idu-eeprom-view-filter" style={{ width: "100%", minWidth: 0 }}>
                <div className="py-15 ">
                    <Grid container style={{ marginBottom: "20px" }} spacing={2}>
                        <Grid item xs={12} sm={2} style={{ marginTop: "10px" }}>
                            <label className="title">Search By: </label>
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <div className="search-by-radios" style={{ display: 'flex', flexDirection: 'row', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
                                <label htmlFor="search-by-model-id" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                                    <input
                                        id="search-by-model-id"
                                        type="radio"
                                        name="searchBy"
                                        value="searchByModelId"
                                        checked={searchBy === "searchByModelId"}
                                        onChange={handleSearchByChange}
                                    />
                                    <span>Model ID</span>
                                </label>
                                <label htmlFor="search-by-config-id" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                                    <input
                                        id="search-by-config-id"
                                        type="radio"
                                        name="searchBy"
                                        value="searchByConfigId"
                                        checked={searchBy === "searchByConfigId"}
                                        onChange={handleSearchByChange}
                                    />
                                    <span>Config ID</span>
                                </label>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} className="mb-0" style={{ width: "100%", minWidth: 0 }}>
                        {searchBy === "searchByModelId" && (
                            <Grid item xs={12} sm={6} md={2} style={{ minWidth: 160 }}>
                                <label className="title">Category</label>
                                <div className="model-srch reset width-md" style={{ width: "100%", minWidth: 160, minHeight: 40 }}>
                                    <FormControl variant="outlined" size="small" fullWidth className="custom-select select-reset radius-20">
                                        <Select
                                            name="categoryFilter"
                                            value={categoryFilter}
                                            onChange={(e) => setCategoryFilter(e.target.value)}
                                            displayEmpty
                                            renderValue={(v) => v || "Select Category"}
                                            MenuProps={selectMenuProps}
                                        >
                                            <MenuItem value="Select Category">Select Category</MenuItem>
                                            {(allowedDeviceCategories || []).map((element) => (
                                                <MenuItem key={element} value={element}>{element}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                        )}
                        {searchBy === "searchByModelId" && (
                            <Grid item xs={12} sm={6} md={2} style={{ minWidth: 160 }}>
                                <label className="title">Brand</label>
                                <div className="model-srch reset width-md" style={{ width: "100%", minWidth: 160, minHeight: 40 }}>
                                    <FormControl variant="outlined" size="small" fullWidth className="custom-select select-reset radius-20">
                                        <Select
                                            name="brandFilter"
                                            value={brandFilter}
                                            onChange={(e) => setBrandFilter(e.target.value)}
                                            displayEmpty
                                            renderValue={(v) => v || "Select Brand"}
                                            MenuProps={selectMenuProps}
                                        >
                                            <MenuItem value="Select Brand">Select Brand</MenuItem>
                                            {(allowedCompanyBrand || []).map((element) => (
                                                <MenuItem key={element} value={element}>{element}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                        )}
                        {searchBy === "searchByModelId" && (
                            <Grid item xs={12} sm={6} md={2} style={{ minWidth: 160 }}>
                                <label className="title">Model ID</label>
                                <div className="model-srch reset width-md" style={{ width: "100%", minWidth: 160, minHeight: 40 }}>
                                    <FormControl variant="outlined" size="small" fullWidth className="custom-select select-reset radius-20">
                                        <Select
                                            name="modelNumberFilter"
                                            value={modelNumberFilter}
                                            onChange={(e) => setModelNumberFilter(e.target.value)}
                                            displayEmpty
                                            renderValue={(v) => {
                                                if (!v || v === "Select Model ID") return "Select Model ID";
                                                try {
                                                    const obj = JSON.parse(v);
                                                    return obj?.modelId ?? obj ?? v;
                                                } catch {
                                                    return v;
                                                }
                                            }}
                                            MenuProps={selectMenuProps}
                                        >
                                            <MenuItem value="Select Model ID">Select Model ID</MenuItem>
                                            {(modelNumberFilterList || []).map((element, idx) => (
                                                <MenuItem key={element?.modelId ?? idx} value={JSON.stringify(element)}>{element?.modelId ?? element}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                        )}
                        {searchBy === "searchByConfigId" && (
                            <Grid item xs={12} sm={6} md={2} style={{ minWidth: 160 }}>
                                <label className="title">Config ID</label>
                                <div className="model-srch reset width-md" style={{ width: "100%", minWidth: 160, minHeight: 40 }}>
                                    <input
                                        className="add-input md border-1"
                                        placeholder="Enter Config ID"
                                        type="text"
                                        name="configIdFilter"
                                        value={configIdFilter}
                                        onChange={(e) => setConfigIdFilter(e.target.value)}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                            </Grid>
                        )}
                        <Grid item xs={12} sm={6} md={2} className="idu-eeprom-view-filter-buttons">
                            <button
                                className="btn btn-style-2 orange-bg ml-15 mb-15"
                                onClick={filterIDUConfigData}
                            >
                                Filter
                            </button>
                            <button
                                className="btn btn-style-2 dark-text gray-bg ml-15 mb-15"
                                onClick={resetFilters}
                            >
                                Reset
                            </button>
                        </Grid>
                    </Grid>
                </div>
            </div>
            {
                searchBy==="searchByConfigId" && showIDUConfigDataList &&
                <div className="py-15 " style={{ float: 'right', marginRight: '20px' }}>
                    <button
                        className="btn btn-style-2 orange-bg ml-15 mb-15"
                        onClick={handleEditByConfigId}
                    >
                        Edit Configuration
                    </button>
                </div>
            }
            {
                showIDUConfigDataList &&
                <div className="content-block bottom-shadow py-15 mb-30">
                    <div className="row mb-0">
                        <div className="col s12">
                            <div
                                className="table-wrapper mb-20"
                                style={{
                                    overflowX: "scroll",
                                    scrollBehavior: "auto",
                                    maxHeight: "58vh",
                                    overflowY: "scroll",
                                }}
                            >
                                <table
                                    width="100%"
                                    align="center"
                                    className="table style-4 mb-20 manufacturedDevicesTable"
                                >
                                    <thead
                                        style={{ position: "sticky", top: 0, zIndex: 50, background: "white" }}
                                    >
                                        <tr>
                                            {Object.keys(headers).map((key) => (
                                                (key!=='editIDUConfig' || searchBy!=='searchByConfigId') &&
                                                <th>{headers[key]}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {iduConfigData.length === 0 ? (
                                            <tr>
                                                <td colSpan={Object.keys(headers).length}>
                                                    No Data found
                                                </td>
                                            </tr>
                                        ) : (
                                            iduConfigData
                                                .map((element, index) => {
                                                    return (
                                                        <tr key={index} id={index}>
                                                            {Object.keys(headers).map((key) => {
                                                                return (
                                                                    key==="iduConfigFileObjectBin" ?
                                                                        <td
                                                                            className={
                                                                                String(element[key]).length > 200
                                                                                    ? "breakWord"
                                                                                    : ""
                                                                            }
                                                                        >
                                                                            <u><a href="javascript:void(0)" onClick={() => {
                                                                                downloadFile(element["iduConfigFileObjectBin"])
                                                                            }}><CloudDownload style={{ color: "black" }}></CloudDownload></a></u>
                                                                        </td>
                                                                        :
                                                                        key==="editIDUConfig" && searchBy==="searchByModelId" ?
                                                                            <td>
                                                                                <a href="javascript:void(0)" onClick={() => {
                                                                                    editIDUConfig(element["iduConfigVersion"], element["configId"], element["modelId"], element["iduConfigFileObjectBin"])
                                                                                }}><EditIcon style={{ color: "black" }}></EditIcon></a>
                                                                            </td>
                                                                            :
                                                                            <td
                                                                                className={
                                                                                    String(element[key]).length > 200
                                                                                        ? "breakWord"
                                                                                        : ""
                                                                                }
                                                                            >
                                                                                {element[key] ? element[key] : ""}
                                                                            </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );
                                                })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
}

const UploadIDUEEPROMConfig = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    iduConfigStore: { uploadIDUConfigInProgress, uploadIDUConfigSuccess },
    uploadedIDUConfigData,
    editIDUConfig,
    uploadIDUConfig,
    updateIDUConfigByModelId,
    updateIDUConfigByConfigId,
    cancelEditIDUConfig,
    setAlert }) => {

    const theme = useTheme();

    const [uploadedCategoryName, setUploadedCategoryName] = useState(uploadedIDUConfigData["categoryName"] || "")
    const [uploadedBrandName, setUploadedBrandName] = useState(uploadedIDUConfigData["brandName"] || "")
    const [modelNumbersList, setModelumbersList] = useState([])
    const [uploadedModelNumbers, setUploadedModelNumbers] = useState(uploadedIDUConfigData["model"] || [])
    const [uploadedIDUConfigVersion, setUploadedIDUConfigVersion] = useState(uploadedIDUConfigData["configversion"] || "")
    const [uploadedIDUConfigImage, setUploadedIDUConfigImage] = useState("")
    const [uploadedIDUConfigId, setUploadedIDUConfigId] = useState(uploadedIDUConfigData["configId"] || "")
    const [updateIDUConfigBy, setUpdateIDUConfigBy] = useState(uploadedIDUConfigData['updateIDUConfigBy'] || "updateConfigByModelId") // by default set to this value

    const allModelNumbersSelected = modelNumbersList.length === uploadedModelNumbers.length
    const iduConfigImageInput = useRef()

    useEffect(() => {
        if (!uploadIDUConfigInProgress && uploadIDUConfigSuccess) {
            setUploadedCategoryName("")
            setUploadedBrandName("")
            setUploadedModelNumbers([])
            setUploadedIDUConfigVersion("")
            setUploadedIDUConfigImage("")
            setUploadedIDUConfigId("")
            setUpdateIDUConfigBy("")

            iduConfigImageInput.current.value = ""

            if (editIDUConfig) {
                cancelEditIDUConfig() //redirect the user to view page
            }
        }
    }, [uploadIDUConfigInProgress, uploadIDUConfigSuccess])

    useEffect(() => {
        if (!uploadedCategoryName || uploadedCategoryName.length===0 || uploadedCategoryName==="Select Category") {
            return
        }

        if (!uploadedBrandName || uploadedBrandName.length===0 || uploadedBrandName==="Select Brand") {
            return
        }

        if (uploadedBrandName && uploadedBrandName.length!==0 && uploadedCategoryName && uploadedCategoryName.length!==0) {
            getDeviceModelNumbersList(uploadedBrandName, uploadedCategoryName)
                .then((data) => {
                    setModelumbersList(data)
                    if (!editIDUConfig) {
                        setUploadedModelNumbers([])
                    }
                })
                .catch((err) => {
                    setModelumbersList([])
                    setUploadedModelNumbers([])
                })
        }
    }, [uploadedBrandName, uploadedCategoryName])

    useEffect(() => {
        if (editIDUConfig && uploadedIDUConfigData && Object.keys(uploadedIDUConfigData).length!==0) {
            setUploadedCategoryName(uploadedIDUConfigData["categoryName"] || "")
            setUploadedBrandName(uploadedIDUConfigData["brandName"] || "")
            setUploadedIDUConfigVersion(uploadedIDUConfigData["iduConfigVersion"] || "")
            setUploadedModelNumbers(uploadedIDUConfigData["model"] || [])
            setUploadedIDUConfigId(uploadedIDUConfigData["configId"])
            setUpdateIDUConfigBy(uploadedIDUConfigData['updateIDUConfigBy'] || "updateConfigByModelId")
            setUploadedIDUConfigImage("")

            iduConfigImageInput.current.value = ""
        } else {
            setUploadedCategoryName("")
            setUploadedBrandName("")
            setUploadedIDUConfigVersion("")
            setUploadedModelNumbers([])
            setUploadedIDUConfigId("")
            setUpdateIDUConfigBy("")
            setUploadedIDUConfigImage("")

            iduConfigImageInput.current.value = ""
        }

        if (uploadedIDUConfigData && uploadedIDUConfigData['updateIDUConfigBy']==="updateConfigByConfigId") {
            //get the list of model ids..
            getDeviceModelIdsUsingConfigId(uploadedIDUConfigData["configId"])
                .then((res) => {
                    setUploadedModelNumbers(res.map((modelId) => {
                        return { 'modelId': modelId, 'modelNumber': "" }
                    }))
                })
                .catch((err) => {
                    //do nothing
                })
        }

    }, [editIDUConfig, uploadedIDUConfigData])

    const handleUploadModelNumbers = (event, selectedOptions, reason) => {
        if (reason === "select-option" || reason === "remove-option") {
            if (selectedOptions.find((option) => option === "Select All")) {

                if (!allModelNumbersSelected) {
                    setUploadedModelNumbers([...modelNumbersList]);
                } else {
                    setUploadedModelNumbers([]);
                }
            } else {
                setUploadedModelNumbers(selectedOptions)
            }
        } else if (reason === "clear") {
            setUploadedModelNumbers([]);
        }
    };

    const handleModelNumberRenderer = (option, { selected }) => {
        const selectAllProps =
            option === "Select All"
                ? { checked: allModelNumbersSelected }
                : {};
        return (
            <Fragment>
                <Checkbox
                    color="primary"
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    {...selectAllProps}
                />
                {option["modelId"] || "Select All"}
            </Fragment>
        );
    };

    function handleUploadIDUConfig() {
        if (!editIDUConfig || (editIDUConfig && updateIDUConfigBy==="updateConfigByModelId")) {
            if (!uploadedCategoryName || uploadedCategoryName.length===0) {
                setAlert('Category Name Cannot be Empty', 'danger')
                return
            }
            if (!uploadedBrandName || uploadedBrandName.length===0) {
                setAlert('Brand Name Cannot be Empty', 'danger')
                return
            }
            if (!uploadedModelNumbers || uploadedModelNumbers.length===0) {
                setAlert('Model IDs Cannot be Empty', 'danger')
                return
            }
        }

        if (!uploadedIDUConfigVersion || uploadedIDUConfigVersion.length===0 || uploadedIDUConfigVersion.match('^[0-9]{1,2}\\.[0-9]{1,2}$')===null) {
            setAlert('Invalid IDU Config Version', 'danger')
            return
        }
        if (!uploadedIDUConfigImage || uploadedIDUConfigImage==="" || !(uploadedIDUConfigImage.name.endsWith('.bin') || uploadedIDUConfigImage.name.endsWith('.BIN'))) {
            setAlert('Invalid IDU Config Image', 'danger')
            return
        }

        if (editIDUConfig) {
            if (updateIDUConfigBy==="updateConfigByModelId") {
                let modelId = uploadedModelNumbers.map((obj) => obj["modelId"])?.join(',') ?? ''
                let formData = new FormData()
                formData.append('iduConfigVersion', uploadedIDUConfigVersion)
                formData.append('iduConfigFile', uploadedIDUConfigImage)

                updateIDUConfigByModelId(modelId, formData)
            }
            else if (updateIDUConfigBy==="updateConfigByConfigId") {
                let configId = uploadedIDUConfigId
                let formData = new FormData()
                formData.append('iduConfigVersion', uploadedIDUConfigVersion)
                formData.append('iduConfigFile', uploadedIDUConfigImage)

                updateIDUConfigByConfigId(configId, formData)
            }
        }
        else {
            let formData = new FormData()
            formData.append('category', uploadedCategoryName)
            formData.append('modelId', uploadedModelNumbers.map((obj) => obj["modelId"])?.join(',') ?? '')
            formData.append('iduConfigVersion', uploadedIDUConfigVersion)
            formData.append('iduConfigFile', uploadedIDUConfigImage)

            uploadIDUConfig(formData)
        }
    };

    function handleIDUConfigUploadReset() {
        setUploadedCategoryName("")
        setUploadedBrandName("")
        setUploadedModelNumbers([])
        setUploadedIDUConfigVersion("")
        setUploadedIDUConfigImage("")
        setUploadedIDUConfigId("")
        setUpdateIDUConfigBy("updateConfigByModelId")

        iduConfigImageInput.current.value = ""
    }

    function handleCancelEditIduConfig() {
        cancelEditIDUConfig()
    }

    const filter = createFilterOptions();

    return (<Fragment>
        <div className="content-block bottom-shadow">
            <div className="py-15 ">
                {
                    // in case of update/edit by model id or new upload same user interface is visible
                    // but in case of edit these fields are set to disabled

                    (editIDUConfig===false || (editIDUConfig===true && updateIDUConfigBy==='updateConfigByModelId')) ?
                        <Fragment>
                            <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                                <Grid item xs={12} md={2} style={{ marginTop: "10px" }}>
                                    <label className="title">Category: </label>
                                </Grid>
                                <Grid item xs={12} md={10} style={{ minWidth: 0 }}>
                                    <Box sx={formControlSx(theme)}>
                                        <FormControl variant="outlined" sx={selectValuesSx} fullWidth disabled={editIDUConfig ? true : false}>
                                            <InputLabel id="select-outlined-label-category-name" className="title">Select Category</InputLabel>
                                            <Select
                                                labelId="select-outlined-label-category-name"
                                                id="select-outlined-ctageory-name-id"
                                                value={uploadedCategoryName}
                                                onChange={(e) => {
                                                    setUploadedCategoryName(e.target.value)
                                                }}
                                                label="Select Category"
                                                sx={selectInputSx}
                                                MenuProps={selectMenuProps}
                                            >
                                                {
                                                    allowedDeviceCategories.map(categoryName => {
                                                        return <MenuItem key={categoryName} value={categoryName}>{categoryName}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                                <Grid item xs={12} md={2} style={{ marginTop: "10px" }}>
                                    <label className="title">Brand: </label>
                                </Grid>
                                <Grid item xs={12} md={10} style={{ minWidth: 0 }}>
                                    <Box sx={formControlSx(theme)}>
                                        <FormControl variant="outlined" sx={selectValuesSx} fullWidth disabled={editIDUConfig ? true : false}>
                                            <InputLabel id="select-outlined-label-brand-name">Select Brand</InputLabel>
                                            <Select
                                                labelId="select-outlined-label-brand-name"
                                                id="select-outlined-brand-name-id"
                                                value={uploadedBrandName}
                                                onChange={(e) => {
                                                    setUploadedBrandName(e.target.value)
                                                }}
                                                label="Select Brand"
                                                sx={selectInputSx}
                                                MenuProps={selectMenuProps}
                                            >
                                                {
                                                    allowedCompanyBrand.map(brandName => {
                                                        return <MenuItem key={brandName} value={brandName}>{brandName}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>

                        </Fragment>
                        :
                        <Fragment>
                            <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                                <Grid item xs={12} md={2} style={{ marginTop: "10px" }}>
                                    <label>Config Id: </label>
                                </Grid>
                                <Grid item xs={12} md={10} style={{ minWidth: 0 }}>
                                    <Box sx={formControlSx(theme)}>
                                        <input
                                            className="add-input xl"
                                            placeholder="Enter IDU Config Version"
                                            type="text"
                                            style={{ width: "100%", boxSizing: "border-box" }}
                                            value={uploadedIDUConfigId}
                                            onChange={(e) => {
                                                setUploadedIDUConfigId(e.target.value)
                                            }}
                                            disabled={true}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Fragment>
                }

                <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                    <Grid item xs={12} md={2} style={{ marginTop: "10px" }}>
                        <label className="title">Model ID: </label>
                    </Grid>
                    <Grid item xs={12} md={10} style={{ minWidth: 0 }}>
                        <Box sx={formControlSx(theme)}>
                            <Autocomplete
                                multiple
                                size="small"
                                limitTags={10}
                                options={modelNumbersList}
                                value={uploadedModelNumbers}
                                disableCloseOnSelect
                                getOptionLabel={(option) => {
                                if (option == null) return '';
                                if (typeof option === 'string') return option;
                                return option.modelId != null ? String(option.modelId) : '';
                            }}
                                renderOption={handleModelNumberRenderer}
                                onChange={handleUploadModelNumbers}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" label="Select Model IDs" placeholder="Search" />
                                )}
                                filterOptions={(options, params) => {
                                    const filtered = filter(options, params);
                                    if (!uploadedCategoryName || uploadedCategoryName.length == 0 || !uploadedBrandName || uploadedBrandName.length == 0
                                        || uploadedCategoryName == "Select Category" || uploadedBrandName == "Select Brand") {
                                        return []
                                    }
                                    return ["Select All", ...filtered];
                                }}
                                isOptionEqualToValue={(option, value) => {
                                    if (option === value) return true;
                                    if (option?.modelId != null && value?.modelId != null) return option.modelId === value.modelId;
                                    return false;
                                }}
                                ListboxProps={{ style: { maxHeight: 250 } }}
                                disabled={editIDUConfig ? true : false}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                    <Grid item xs={12} md={2} style={{ marginTop: "10px" }}>
                        <label>Config Version: </label>
                    </Grid>
                    <Grid item xs={12} md={10} style={{ minWidth: 0 }}>
                        <Box sx={formControlSx(theme)}>
                            <input
                                className="add-input xl"
                                placeholder="Enter IDU Config Version"
                                type="text"
                                style={{ width: "100%", boxSizing: "border-box" }}
                                value={uploadedIDUConfigVersion}
                                onChange={(e) => {
                                    setUploadedIDUConfigVersion(e.target.value)
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                    <Grid item xs={12} md={2} style={{ marginTop: "10px" }}>
                        <label className="title">IDU Config Image: </label>
                    </Grid>
                    <Grid item xs={12} md={10} style={{ minWidth: 0 }}>
                        <Box sx={formControlSx(theme)}>
                            <input
                                className="md border-1"
                                placeholder="Upload IDU Config File"
                                type="file"
                                style={{ width: "100%", boxSizing: "border-box" }}
                                name={uploadedIDUConfigImage?.name ?? uploadedIDUConfigImage}
                                onChange={(e) => {
                                    setUploadedIDUConfigImage(e.target.files[0])
                                }}
                                ref={iduConfigImageInput}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <div className="row">
                    <button
                        className="btn btn-style-2 orange-bg ml-15 mb-15"
                        onClick={handleUploadIDUConfig}
                        disabled={uploadIDUConfigInProgress ? true : false}
                    >
                        {
                            uploadIDUConfigInProgress ? <Fragment>
                                <CircularProgress size="2em" style={{ color: "#AFB42B", marginTop: "5px" }} />
                            </Fragment>
                                : "Upload"
                        }
                    </button>
                    {
                        editIDUConfig ? <button
                            className="btn btn-style-2 dark-text gray-bg ml-15 mb-15" onClick={handleCancelEditIduConfig}
                        >
                            Cancel
                        </button>
                            :
                            <button
                                className="btn btn-style-2 dark-text gray-bg ml-15 mb-15" onClick={handleIDUConfigUploadReset}
                            >
                                Reset
                            </button>
                    }
                </div>
            </div>
        </div>
    </Fragment>
    );
}

const MQTTTriggerIDUEEPROMConfig = ({
    iduConfigStore: { iduConfigMQTTTriggerInProgress, iduConfigMQTTTriggerSuccess },
    sendIDUConfigMQTTTrigger,
    setAlert }) => {

    const theme = useTheme();
    const [uploadedDeviceId, setUploadedDeviceId] = useState("")

    useEffect(() => {
        if (!iduConfigMQTTTriggerInProgress && iduConfigMQTTTriggerSuccess) {
            setUploadedDeviceId("")
        }
    }, [iduConfigMQTTTriggerInProgress, iduConfigMQTTTriggerSuccess])

    function handleIDUConfigMQTTTrigger() {
        if (!uploadedDeviceId || uploadedDeviceId.length===0) {
            setAlert('Invalid Device Id', 'danger')
            return
        }
        sendIDUConfigMQTTTrigger(uploadedDeviceId)
    };

    function handleIDUConfigTriggerReset() {
        setUploadedDeviceId("")
    }

    return (<Fragment>
        <div className="content-block bottom-shadow idu-eeprom-push-config">
            <div className="py-15 ">
                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "12px", marginBottom: "20px" }}>
                    <label style={{ margin: 0, flex: "0 0 auto", whiteSpace: "nowrap" }}>Device Id:</label>
                    <Box sx={{ ...formControlSx(theme), flex: "1 1 auto", minWidth: 0, maxWidth: 280 }}>
                        <input
                            className="add-input idu-eeprom-push-device-input"
                            placeholder="Enter Device Id"
                            type="text"
                            style={{ width: "100%", boxSizing: "border-box" }}
                            value={uploadedDeviceId}
                            onChange={(e) => {
                                setUploadedDeviceId(e.target.value)
                            }}
                        />
                    </Box>
                </div>
                <div className="row">
                    <button
                        className="btn btn-style-2 orange-bg ml-15 mb-15"
                        onClick={handleIDUConfigMQTTTrigger}
                        disabled={iduConfigMQTTTriggerInProgress ? true : false}
                    >
                        {
                            iduConfigMQTTTriggerInProgress ? <Fragment>
                                <CircularProgress size="2em" style={{ color: "#AFB42B", marginTop: "5px" }} />
                            </Fragment>
                                : "Send"
                        }
                    </button>
                    <button
                        className="btn btn-style-2 dark-text gray-bg ml-15 mb-15" onClick={handleIDUConfigTriggerReset}
                    >
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </Fragment>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
    iduConfigStore: state.iduConfig
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    uploadIDUConfig: (formData) => dispatch(uploadIDUConfig(formData)),
    updateIDUConfigByModelId: (modelId, formData) => dispatch(updateIDUConfigByModelId(modelId, formData)),
    updateIDUConfigByConfigId: (configId, formData) => dispatch(updateIDUConfigByConfigId(configId, formData)),
    downloadIDUConfigFile: (params) => dispatch(downloadIDUConfigFile(params)),
    sendIDUConfigMQTTTrigger: (params) => dispatch(sendIDUConfigMQTTTrigger(params))
});

export default connect(mapStateToProps, mapDispatchToProps)(IDUEEPROMConfig);

